import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { FinCampaniaPage } from './fin-campania';

// Translation
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';

import { DirectivesModule } from '../../directives/directives.module';

@NgModule({
  declarations: [
    FinCampaniaPage,
  ],
  imports: [
    IonicPageModule.forChild(FinCampaniaPage),
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: (http: HttpClient) => new TranslateHttpLoader(http),
          deps: [ HttpClient ]
        }
    }),
    DirectivesModule
  ],
})
export class FinCampaniaPageModule {}



// WEBPACK FOOTER //
// ./src/pages/fin-campania/fin-campania.module.ts